// @flow
import queryString from "query-string";
import { APP_NAMESPACE } from "shared/constants/application";
import { CALL_API } from "redux/middleware/api";
import type { callApiReturnType } from "redux/middleware/api";
import { EVENTS_API_ENDPOINTS } from "redux/modules/createCabelasClass/constants";
import {
  CANCELLED_STATUS,
  receiveReviewStatusCounts,
  requestReviewStatusCounts,
  reviewStatusCountsRequestError,
  updateCabelasClassEvent,
} from "redux/modules/instructorCabelasClasses/instructorCabelasClasses";
import type {
  CabelasClassesParams,
  EventUpdateValues,
} from "redux/modules/instructorCabelasClasses/instructorCabelasClasses";
import { CHAPTER_EVENT_TYPES } from "redux/modules/instructorChapters/constants";

const namespace = `${APP_NAMESPACE}/instructorChapterEvents`;
export const REQUEST = `${namespace}/FETCH/REQUEST`;

export type ChapterEventsAction = {
  type: string,
  payload: CabelasClassesParams,
};

export const getChapterEvents = (
  params: CabelasClassesParams = {}
): ChapterEventsAction => ({
  type: REQUEST,
  payload: params,
});

export const getChapterReviewStatusCounts = (): callApiReturnType => ({
  type: CALL_API,
  payload: {
    method: "GET",
    endpoint: `${
      EVENTS_API_ENDPOINTS.REVIEW_STATUS_COUNTS
    }?${queryString.stringify({
      "filter[type][_in]": JSON.stringify(CHAPTER_EVENT_TYPES),
      "filter[status][_neq]": CANCELLED_STATUS,
    })}`,
    actionParams: requestReviewStatusCounts().payload,
    actions: {
      request: requestReviewStatusCounts,
      success: receiveReviewStatusCounts,
      failure: reviewStatusCountsRequestError,
    },
    disableErrorToast: true,
  },
});

export const updateChapterEvent = (
  eventId: string,
  updates: EventUpdateValues
): callApiReturnType => {
  const action = updateCabelasClassEvent(eventId, updates);

  return {
    ...action,
    payload: {
      ...action.payload,
      toasts: {
        ...action.payload.toasts,
        failure: "Couldn't update Chapter event",
      },
    },
  };
};
